import React from 'react';
import './ShippingPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="policy-title">Privacy Policy</div>
      <div className="last-updated">Last updated: October 26, 2024</div>

      <div className="policy-section">
        <p>
          This Privacy Policy describes how Swapnil Sharma (the "Site", "we", "us", or "our") collects, uses, and discloses your personal information when you visit, use our services, or make a purchase from <a href="https://swapnilsharma.in">swapnilsharma.in</a> (the "Site") or otherwise communicate with us regarding the Site (collectively, the "Services"). For purposes of this Privacy Policy, "you" and "your" means you as the user of the Services, whether you are a customer, website visitor, or another individual whose information we have collected pursuant to this Privacy Policy.
        </p>
        <p>
          Please read this Privacy Policy carefully. By using and accessing any of the Services, you agree to the collection, use, and disclosure of your information as described in this Privacy Policy. If you do not agree to this Privacy Policy, please do not use or access any of the Services.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">Changes to This Privacy Policy</div>
        <p>
          We may update this Privacy Policy from time to time, including to reflect changes to our practices or for other operational, legal, or regulatory reasons. We will post the revised Privacy Policy on the Site, update the "Last updated" date, and take any other steps required by applicable law.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">How We Collect and Use Your Personal Information</div>
        <p>
          To provide the Services, we collect personal information about you from a variety of sources, as set out below. The information that we collect and use varies depending on how you interact with us.
        </p>
        <p>
          In addition to the specific uses set out below, we may use information we collect about you to communicate with you, provide or improve our Services, comply with any applicable legal obligations, enforce any applicable terms of service, and to protect or defend the Services, our rights, and the rights of our users or others.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">What Personal Information We Collect</div>
        <p>
          The types of personal information we obtain about you depend on how you interact with our Site and use our Services. When we use the term "personal information", we are referring to information that identifies, relates to, describes, or can be associated with you. The following sections describe the categories and specific types of personal information we collect.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">Information We Collect Directly from You</div>
        <ul>
          <li>Contact details including your name, address, phone number, and email.</li>
          <li>Order information including your name, billing address, shipping address, payment confirmation, email address, and phone number.</li>
          <li>Customer support information including the information you choose to include in communications with us, for example, when sending a message through the Services.</li>
        </ul>
      </div>

      <div className="policy-section">
        <div className="section-title">Information We Collect about Your Usage</div>
        <p>
          We may also automatically collect certain information about your interaction with the Services ("Usage Data"). To do this, we may use cookies, pixels, and similar technologies ("Cookies"). Usage Data may include information about how you access and use our Site and your account, including device information, browser information, information about your network connection, your IP address, and other information regarding your interaction with the Services.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">How We Use Your Personal Information</div>
        <ul>
          <li>
            <strong>Providing Products and Services:</strong> We use your personal information to provide you with the Services in order to perform our contract with you, including processing your payments, fulfilling your orders, sending notifications related to your account, purchases, returns, exchanges, and other transactions.
          </li>
          <li>
            <strong>Marketing and Advertising:</strong> We may use your personal information for marketing and promotional purposes, such as to send marketing, advertising, and promotional communications by email, text message, or postal mail, and to show you advertisements for products or services.
          </li>
          <li>
            <strong>Security and Fraud Prevention:</strong> We use your personal information to detect, investigate or take action regarding possible fraudulent, illegal, or malicious activity.
          </li>
          <li>
            <strong>Communicating with You and Service Improvement:</strong> We use your personal information to provide you with customer support and improve our Services.
          </li>
        </ul>
      </div>

      <div className="policy-section">
        <div className="section-title">How We Disclose Personal Information</div>
        <p>
          In certain circumstances, we may disclose your personal information to third parties for contract fulfillment purposes, legitimate purposes, and other reasons subject to this Privacy Policy.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">Third Party Websites and Links</div>
        <p>
          Our Site may provide links to websites or other online platforms operated by third parties. If you follow links to sites not affiliated or controlled by us, you should review their privacy and security policies and other terms and conditions.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">Children's Data</div>
        <p>
          The Services are not intended to be used by children, and we do not knowingly collect any personal information about children.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">Security and Retention of Your Information</div>
        <p>
          Please be aware that no security measures are perfect or impenetrable, and we cannot guarantee “perfect security.” 
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">Your Rights</div>
        <p>
          Depending on where you live, you may have some or all of the rights listed below in relation to your personal information.
        </p>
      </div>

      <div className="policy-section">
        <div className="section-title">Contact</div>
        <p>
          Should you have any questions about our privacy practices or this Privacy Policy, or if you would like to exercise any of the rights available to you, please call or email us at <a href="mailto:info@swapnilsharma.in">info@swapnilsharma.in</a>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
